import styled from "styled-components";
import React from "react";
import {css} from "styled-components";

export const CheckBoxStyle = styled.input.attrs({
    tabIndex: "0",
})`
    width: auto;

    opacity: 0.00000001;
    position: absolute;
    left: 0;
    margin-left: -20px;
    outline: none;

    &:checked ~ label {
        &:before {
            border: ${({color, theme}) =>
                    color ? `2px solid ${color}` : `2px solid ${theme.colors.primary}`};
        }

        &:after {
            transform: rotate(-45deg) scale(1);
        }
    }

    &:focus {
        outline: none;
    }

    &:focus + label {
        outline-offset: 5px;
        outline: ${({theme}) => theme.colors.primaryDark} solid 2px;
    }
`;
export const CheckboxWrapper = styled.div.attrs(
    ({displayLayout, justifyContent, alignItems, flexDirection}) => ({
        displayLayout: displayLayout ? displayLayout : "block",
        justification: justifyContent ? justifyContent : "flex-start",
        flexDirection: flexDirection ? flexDirection : undefined,
        alignment: alignItems ? alignItems : "stretch",
    })
)`
    width: 100%;
    position: relative;
    display: ${({displayLayout}) => displayLayout};
    ${({displayLayout}) =>
            displayLayout === "flex" &&
            css`
                justify-content: ${({justification}) => justification};
                align-items: ${({alignment}) => alignment};

                span {
                    min-width: 50px;
                }
            `}
    ${({flexDirection, displayLayout}) =>
            flexDirection !== undefined &&
            displayLayout === "flex" &&
            css`
                flex-direction: ${({flexDirection}) => flexDirection};
            `}
`;
export const CheckBoxLabel = styled.label`
    position: relative;
    min-height: 34px;
    display: block;
    padding-left: 35px;
    margin-bottom: 0;
    font-weight: normal;
    cursor: pointer;

    span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }

    &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        margin: 4px;
        width: 22px;
        height: 22px;
        transition: transform 0.28s ease;
        border-radius: 3px;
        border: ${({color, theme}) =>
                color ? `2px solid ${color}` : `2px solid ${theme.colors.grey}`};
    }

    &:after {
        content: "";
        display: block;
        width: 10px;
        height: 5px;
        border-bottom: ${({color, theme}) =>
                color ? `2px solid ${color}` : `2px solid ${theme.colors.primary}`};
        border-left: ${({color, theme}) =>
                color ? `2px solid ${color}` : `2px solid ${theme.colors.primary}`};
        transform: rotate(-45deg) scale(0);
        transition: transform ease 0.25s;
        position: absolute;
        top: 12px;
        left: 10px;
    }
`;
export const CheckBox = ({color, size, register, label, name}) => {
    return (
        <CheckboxWrapper>
            <CheckBoxStyle
                color={color}
                ref={register}
                type="checkbox"
                id={name}
                name={name}
                value=""
            ></CheckBoxStyle>
            <CheckBoxLabel role={"checkbox"} tabIndex="0" color={color} size={size} htmlFor={name}>
                <span>{label}</span>
            </CheckBoxLabel>
        </CheckboxWrapper>
    );
};
